import React, { useEffect, useRef, useState } from 'react';
import { useSelector } from "react-redux";
import { useAxiosIndicatorCheck } from 'src/store/hook/useAxiosIndicatorCheck';
import AxiosIndicatorRunTimeLoader from './AxiosIndicatorRunTimeLoader';

export function AxiosSingletonLoader(props) {
    const { slugKey, disabled = false } = props;
    const refLoad = useRef();
    const [load, setLoad] = useState(false);
    const [__check] = useAxiosIndicatorCheck();
    const axios_indicator = useSelector((state) => state.entities.system.axios_indicator);

    useEffect(() => {
        let status = __check(slugKey).status;
        if (status && load) {
            refLoad.current.style.display = 'none';
        } else {
            refLoad.current.style.display = '';
            setLoad(false)
        }
    }, [axios_indicator, load])

    const customAxiosIndicatorRunTimeLoader = () => {
        return (
            load &&
            <a href={void (0)} disabled={true}
                className={"bs5 btn btn-primary btn-sm w-100 disabled"}>
                <i className="fa fa-spinner fa-spin" />
            </a>
        )
    };

    const onLoader = () => {
        if (disabled) {
            return false;
        }
        refLoad.current.style.display = 'none';
        setLoad(true)
    };


    return (
        <>
            {load &&
                <>
                    {(!props.customAxiosButtonIndicatorRunTimeLoader && !props.customAxiosIndicatorRunTimeLoader) ?
                        <AxiosIndicatorRunTimeLoader {...props} />
                        :
                        <>
                            {props.customAxiosIndicatorRunTimeLoader ?
                                <>
                                    {React.createElement(props.customAxiosIndicatorRunTimeLoader)}
                                </>
                                :
                                <>
                                    {props.customAxiosButtonIndicatorRunTimeLoader &&
                                        <>
                                            {customAxiosIndicatorRunTimeLoader()}
                                        </>
                                    }
                                </>
                            }
                        </>
                    }
                </>
            }
            <div ref={refLoad} onClick={onLoader}>
                {props.children}
            </div>

        </>
    );
}

export default AxiosSingletonLoader;